import { Typography } from '@mui/material'
import {
  HelperWrapper,
  LeaderboardComponent,
  MainContainer,
  UserDashboardComponent,
} from 'src/components'
import { ETranslationNs } from 'src/types'

const UserDashboardScreen = () => {
  return (
    <MainContainer
      headerTitle={<HelperWrapper t="dashboard-header-title" ns={ETranslationNs.Navbar} />}
      // withAccountIcon
      // withScanBtn
    >
      <UserDashboardComponent />

      <Typography fontSize={'20px'} fontWeight={700} sx={{ margin: '24px 0' }}>
        Challenge Leaderboard
      </Typography>
      <LeaderboardComponent />
    </MainContainer>
  )
}

export default UserDashboardScreen
